import { apiRequestWithChecks } from "./api";

export const facebook = {
    getAuthUrl(token) {
        return apiRequestWithChecks("GET", "/api/facebook/auth-url", {
            Authorization: "Bearer " + token,
        });
    },
    callback(token, code) {
        return apiRequestWithChecks(
            "POST",
            "/api/facebook/token",
            { Authorization: "Bearer " + token },
            { code }
        );
    },
    getStatus(token) {
        return apiRequestWithChecks("GET", "/api/facebook/status", {
            Authorization: "Bearer " + token,
        });
    },
    disconnect(token) {
        return apiRequestWithChecks("DELETE", "/api/facebook/disconnect", {
            Authorization: "Bearer " + token,
        });
    },
    authenticate(token, data) {
        return apiRequestWithChecks(
            "POST",
            "/api/facebook/authenticate",
            { Authorization: "Bearer " + token },
            data
        );
    },
    changePage(token, data) {
        return apiRequestWithChecks(
            "POST",
            "/api/facebook/change-page",
            { Authorization: "Bearer " + token },
            data
        );
    },
    getPages(token, userAccessToken) {
        return apiRequestWithChecks(
            "POST",
            "/api/facebook/pages",
            { Authorization: "Bearer " + token },
            { userAccessToken }
        );
    },
    postToPage(token, data) {
        return apiRequestWithChecks(
            "POST",
            "/api/facebook/post",
            { Authorization: "Bearer " + token },
            data
        );
    },
    togglePosting(token) {
        return apiRequestWithChecks(
            "POST",
            "/api/facebook/toggle-posting",
            { Authorization: "Bearer " + token }
        );
    },
};

export default facebook;